import { BreakpointObserver, LayoutModule } from '@angular/cdk/layout';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  inject,
} from '@angular/core';
import { map } from 'rxjs';
import { Carousel, CmsFile } from 'www-cms';
import { CarouselControlsComponent } from '../../shared/components/carousel-controls/carousel-controls.component';
import { ImageWithLoaderComponent } from '../components/image-with-loader/image-with-loader.component';
import { BaseBuildingBlockComponent } from '../components/base-building-block.component';
import { LastItemBgClass } from '../../shell/shell.service';
import { SwipeDirective } from '../../shared/directives/swipe.directive';
import { slideRound } from '../info-carousel/info-carousel.animations';
import { DirectusDirective } from 'directus';

@Component({
  selector: 'ss-www-carousel',
  imports: [
    CommonModule,
    CarouselControlsComponent,
    LayoutModule,
    ImageWithLoaderComponent,
    SwipeDirective,
    NgOptimizedImage,
    DirectusDirective,
  ],
  templateUrl: './carousel.component.html',
  styles: [],
  animations: [slideRound],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CarouselComponent extends BaseBuildingBlockComponent {
  animationState = { toLeft: false };
  @Input({ required: true }) carouselData!: Carousel;
  currentIndex = 0;
  isSmallScreen$ = inject(BreakpointObserver)
    .observe(['(max-width: 768px)'])
    .pipe(map((res) => res.breakpoints['(max-width: 768px)']));

  imgTrackBy(index: number, img: CmsFile) {
    return img.directus_files_id.id;
  }
  isCarouselGoingLeft(index: number): boolean {
    if (
      index === 0 &&
      this.currentIndex === this.carouselData.images.length - 1
    ) {
      return false;
    }
    if (
      index === this.carouselData.images.length - 1 &&
      this.currentIndex === 0
    ) {
      return true;
    }
    return index < this.currentIndex;
  }

  setActiveIndex(index: number): void {
    this.animationState = { toLeft: this.isCarouselGoingLeft(index) };
    this.currentIndex = index;
  }

  override getBgClass(): LastItemBgClass {
    return 'bg-ss-www-background';
  }
}
